module.exports = __webpack_public_path__ + "static/media/telegram.0e55904e.svg";